import { apiClient } from '@/services/api/apiClient';
import { ENDPOINTS } from '@/services/api/endpoints';

/**
 * The single org-wide event countdown.
 *
 * One resource with no id — there is at most one countdown, and the server owns
 * its key. `getCountdown` resolves to `null` when none has been set, which is a
 * real state the management screen renders as a prompt to create one.
 */
export const countdownService = {
    async getCountdown() {
        const { data } = await apiClient.get(ENDPOINTS.COUNTDOWN.ROOT);
        return data?.data ?? null;
    },

    async createCountdown(payload) {
        const { data } = await apiClient.post(ENDPOINTS.COUNTDOWN.ROOT, payload);
        return data?.data ?? null;
    },

    async updateCountdown(patch) {
        const { data } = await apiClient.put(ENDPOINTS.COUNTDOWN.ROOT, patch);
        return data?.data ?? null;
    },

    async deleteCountdown() {
        await apiClient.delete(ENDPOINTS.COUNTDOWN.ROOT);
    },
};

export default countdownService;
